<template>
  <page-listado>
    <page-header title="Orígenes de oferta">
      <b-button variant="primary" size="sm" to="/origenOferta/crear">
        <v-icon name="plus" width="16" />
        Crear origen
      </b-button>
    </page-header>
    <tabla :origen-oferta="origenOferta" @eliminar="eliminar" />
  </page-listado>
</template>

<script>
import origenOfertaApi from "@/services/origenOferta.js";
import Tabla from "./TablaOrigenOferta.vue";
export default {
  components: { Tabla },
  data() {
    return {
      origenOferta: [],
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async listar() {
      this.origenOferta = await origenOfertaApi.listar(this.$route.query);
    },
    async eliminar(id) {
      await origenOfertaApi.eliminar(id);
      await this.listar();
    },
  },
};
</script>
